import { ToasterService } from 'angular2-toaster';
import { AddOnTypes, AppService, CoreProxyService, CoreTypes, PushNotificationPayload, PushNotificationService, SharedCommonService } from 'common-cloudstudio';
import { GearProxyService, FacilitiesDrawerComponent, GearAppService, SharedHelpService, CommonGearService, GearTypes } from 'common-gear';
import { Component, OnInit, ViewChild,ViewContainerRef,ComponentRef,HostListener} from '@angular/core';
import { Router, Event, NavigationEnd, NavigationStart } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Chart } from 'chart.js';
import { SharedService } from './shared/services/shared.service';
import { MenuService } from './shared/services/menu.service';

declare var environment;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  _loginPage = true;
  _showTopNav = false;
  _facilityReady: boolean;
  hideNav = true;
  sharedAssets = false;
  addOnFeatureVisibility = AddOnTypes.AddOnVisibilityTypes;
  addOnFeatureIDs = AddOnTypes.AddOnFeatureIDs;
  valueWithUnits: CoreTypes.ValueWithUnits = new CoreTypes.ValueWithUnits();
  useOfflineMode: boolean = false;
  menuList: CoreTypes.MenuHierarchy[] = [];
  maintenanceStatus = CoreTypes.FacilityOperationalStatus.Maintenance;

  private _permissionsLoaded = false;
  private _menuLoaded = false;

  @ViewChild('topNavDirective', { read: ViewContainerRef })
  container: ViewContainerRef;
  private _componentRef: ComponentRef<any>;

  constructor(
    private _router: Router,
    private titleService: Title,
    public _appService: AppService,
    private _toasterService: ToasterService,
    private _gearProxyService: GearProxyService,
    public _gearAppService: GearAppService,
    private _coreProxyService: CoreProxyService,
    private sharedCommonService: SharedCommonService,
    private sharedHelpService: SharedHelpService,
    private commonGearService: CommonGearService,
    public _gearService: GearAppService,
    private sharedService: SharedService,
    private menuService: MenuService,
    private _pushNotificationService: PushNotificationService,
  ) {
    this._appService.onStartingSettings.subscribe(settings => {
      if(!settings) { return; }
    });
    this.useOfflineMode = environment.useOfflineMode;
  }

  ngOnInit() {
    this.titleService.setTitle(this._appService.getTitle());
    this._router.events.subscribe(async (event: Event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.indexOf('login') > -1) {
          this.hideNav = true;
          this._loginPage = true;
        } else {
          this.hideNav = false;
          this._loginPage = false;
        }
        setTimeout(() => { this._gearAppService.setTutorial('Monitor', event.url); }, 100);
        if(this._router.url.indexOf('shared-dashboard') > -1 ||
          this._router.url.indexOf('shared-view') > -1 ||
          this._router.url.indexOf('shared-assets') > -1) {
            this.hideNav = true;
            if(event.url.indexOf('shared-assets') > -1){
              this.sharedAssets = true;
            }
        };
      };
    });

    this.sharedCommonService.onSetClusterParameters.subscribe(data => {
      if (!data?.type) { return; }
      if (data.type === 'getEndpointData') {
        this.getActions(data.id);
        return;
      } else if(data.type === 'onExecAction') {
        if (data.data.action?.ActionType){
          this.valueWithUnits.Value = data.data.type;
          this.sharedService.execAction(data.id, data.data.action.ActionType, this.valueWithUnits);
        }else if(data.data){
          this.valueWithUnits.Value = 0;
          this.sharedService.execAction(data.id, data.data.ActionType, this.valueWithUnits);
        }
      }
    });

    this.setLinks();
    this.getLiterals();

    this._appService.onFacilitySet.subscribe(x => {
      this.setPermissions();
    });

    this._appService.onAccessTokenSet.subscribe(x => {
      this.getLiterals();
      // Boot Firebase messaging and, if the user previously granted
      // permission, silently re-register the FCM token with the backend.
      // If permission is 'default' we do nothing here — the user will be
      // prompted via the bell icon UI (F2) from a click handler.
      this._pushNotificationService.initialize().then(() => {
        if (this._pushNotificationService.getPermissionState() === 'granted') {
          this._pushNotificationService.requestPermissionAndRegister();
        }
      });
    });

    // onAccessTokenSet only fires on explicit login (setAccessToken). On a
    // page reload with the token persisted in storage, the subscriber above
    // never triggers — so initialize() and RegisterDeviceToken never run,
    // leaving the foreground onMessage listener unarmed and the backend
    // with a stale/missing DeviceToken row. Bootstrap explicitly here when
    // a session is already present.
    if (this._appService.getAccessToken()) {
      this._pushNotificationService.initialize().then(() => {
        if (this._pushNotificationService.getPermissionState() === 'granted') {
          this._pushNotificationService.requestPermissionAndRegister();
        }
      });
    }

    this._appService.onLogout.subscribe(() => {
      this.getLiterals();
      setTimeout(() => this.menuService.menuItems.next([]), 600);
      this._pushNotificationService.unregister();
    });

    this._appService.onToasterException.subscribe((x: any) => {
      this._toasterService.pop('error', x.ClassName, x.Message);
    });

    this._appService.setFacilities(FacilitiesDrawerComponent);

    // Set default font family for charts
    Chart.defaults.font.family = 'Nunito';

    this.sharedCommonService.onShareComponent.subscribe(data => {
      if (!data?.type) { return; }
      data.id = (data.id) ? data.id : 0;
      if(data.type === 'manage-snapshots') {
        this._router.navigate(['/', {outlets: {modal: ['manage-snapshots', data.id], }}],{  skipLocationChange: true });
        return;
      }
      let route = 'share-component';
      this._router.navigate(['/', {outlets: {modal: [route, data.type, data.id]}}]);
    });
  }

  setLinks(){
    this.commonGearService.setLinks();
  }

  loadChat(propertyID, widgetEn, widgetEs) {
    if(!propertyID && !widgetEn && !widgetEs) { return; }
    if(window.$_Tawk_AccountKey && window.$_Tawk_AccountKey !== propertyID) {
      setTimeout(() => {
        delete window.$_Tawk_AccountKey;
        delete window.$_Tawk_WidgetId;
        delete window.$_Tawk_Unstable;
        delete window.$_Tawk;
        delete window.Tawk_API;
      }, 100);
    }
    this.sharedHelpService.loadChat(propertyID, widgetEn, widgetEs);
  }

  async getLiterals() {
    await new Promise(resolve => { setTimeout(() => resolve(null), 300); });
    this._gearProxyService.MasterEntityService.GetMonitorLiterals(
      this._appService.getAccessToken(),
      success => {
        this._showTopNav = true;
        this._appService.CoreCommonLiterals = success.Common.Core;
        this._appService.onLiteralsSet.next(true);
        this._gearAppService.GearCommonLiterals = success.Common.Gear;
        this._gearAppService.GearMonitorLiterals = success;
        this._gearAppService.onLiteralsSet.next(true);
      },
      error => {
        this._appService.logout();
      }
    );
    this.getStartingSettings();
  }

  setPermissions() {
    if ( ! this._appService.getAccessToken()) { return; }
    
    this._permissionsLoaded = false;
    this._menuLoaded = false;
    
    this._gearProxyService.MasterEntityService.GetBasicMasterEntities(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      this._appService.getFacilityID(),
      data => {
        data.RegionalFormats.Frontend.DateFormatWithYear = data.RegionalFormats.Frontend.DateFormatWithYear.toLocaleUpperCase();
        data.RegionalFormats.Frontend.DateFormatWithoutYear = data.RegionalFormats.Frontend.DateFormatWithoutYear.toLocaleUpperCase();
        data.RegionalFormats.Frontend.DateTimeFormatWithSeconds = data.RegionalFormats.Frontend.DateFormatWithYear +' '+ data.RegionalFormats.Frontend.TimeFormatWithSeconds;
        data.RegionalFormats.Frontend.DateTimeFormatWithoutSeconds = data.RegionalFormats.Frontend.DateFormatWithYear +' '+ data.RegionalFormats.Frontend.TimeFormatWithoutSeconds;
        this.sharedCommonService.permissionMonitor.next(data.Permissions.Monitor)
        this._appService.onShowTermsConditions.next(data.ClientData.TermsAndConditions);
        this._gearAppService.setAddOnsFeaturesPermissions(data.AddOnFeatures);
        this._gearAppService.setGearPermissionList(data.Permissions);
        this._appService.setMapIconsDetails(data.MapIcons);
        this._appService.relativeTimesList.next({
          DefaultRelativeTimes: data.DefaultRelativeTimes,
          DefaultRelativeTimeRanges: data.DefaultRelativeTimeRanges,
        });
        this._appService.timeZoneData.next(data.TimeZoneData);
        this._appService.setStartingSettings(data.StartingSettings, data.InstanceImages, data.ImageSettings);
        this._appService.regionalFormats.next(data.RegionalFormats);
        this._appService.helpMenuConfiguration.next(data.StartingSettings.HelpMenu);
        if(!this.useOfflineMode && (data.StartingSettings.TawkToImplementation.PropertyID && (data.StartingSettings.TawkToImplementation.WidgetID_EN || data.StartingSettings.TawkToImplementation.WidgetID_ES)) ||
          (!data.StartingSettings.TawkToImplementation.PropertyID && !this._appService.onStartingSettings.value.startingSettings.TawkToImplementation.PropertyID)) {
          this.loadChat(data.StartingSettings.TawkToImplementation.PropertyID, data.StartingSettings.TawkToImplementation.WidgetID_EN, data.StartingSettings.TawkToImplementation.WidgetID_ES);
        }
        
        this._permissionsLoaded = true;
        this.tryExecuteRedirect();
      },
      error => {
        this._appService.showException(error);
      }
    );

    this._coreProxyService.MasterEntityService.GetMenuHierarchy(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      this._appService.getFacilityID(),
      data => {
        this.menuService.menuItems.next(data);
        this.menuList = data;
        if (data?.length && data[0].FacilityOperationalStatus !== undefined) {
          this._appService.facilityOperationalStatus.next(data[0].FacilityOperationalStatus);
        }
        this._menuLoaded = true;
        this.tryExecuteRedirect();
      },
      error => {
        this._appService.showException(error);
      }
    )
  }

  getStartingSettings() {
    this._gearProxyService.MasterEntityService.GetStartingSettings(
      success => {
        this._appService.setStartingSettings(success);
        this._appService.mapIconSet.next(success.MapIcons);
        if(!this.useOfflineMode && (success.TawkToImplementation.PropertyID && (success.TawkToImplementation.WidgetID_EN || success.TawkToImplementation.WidgetID_ES)) && !this._appService.getAccessToken() && !this.hideNav) {
          setTimeout(() => { this.loadChat(success.TawkToImplementation.PropertyID, success.TawkToImplementation.WidgetID_EN, success.TawkToImplementation.WidgetID_ES); }, 1000);
        } else if(!this.useOfflineMode && (success.TawkToImplementation.PropertyID && (success.TawkToImplementation.WidgetID_EN || success.TawkToImplementation.WidgetID_ES)) && this._appService.getAccessToken()) {
          setTimeout(() => {
            let tawkToImplementation = JSON.parse(JSON.stringify({
              PropertyID: success.TawkToImplementation.PropertyID, WidgetID_EN:success.TawkToImplementation.WidgetID_EN, WidgetID_ES: success.TawkToImplementation.WidgetID_ES
            }));
            if(!this.useOfflineMode && (this._appService.onStartingSettings.value.startingSettings.TawkToImplementation.PropertyID && (success.TawkToImplementation.WidgetID_EN || success.TawkToImplementation.WidgetID_ES)) && tawkToImplementation !== this._appService.onStartingSettings.value.startingSettings.TawkToImplementation) { return; }
            this.loadChat(success.TawkToImplementation.PropertyID, success.TawkToImplementation.WidgetID_EN, success.TawkToImplementation.WidgetID_ES); },
          3000);
        }
      },
      (error) => {
        this._appService.showException(error);
      }
    )
  }

  private tryExecuteRedirect() {
    if (this._permissionsLoaded && this._menuLoaded) {
      this.redirect();
    }
  }

  /**
   * Wired from <top-nav (onNotificationSelected)>. User tapped a single
   * entry in the bell dropdown. Navigation priority:
   *   1. payload.clickUrl — explicit URL from SW / backend. Use as-is.
   *   2. payload.facilityId — resolve the facility's active alarms report
   *      via ReportingService, set the facility context, navigate.
   *   3. Fallback — bell opens without further action.
   */
  async onNotificationSelected(payload: PushNotificationPayload) {
    if (!payload) { return; }

    if (payload.clickUrl) {
      this._router.navigateByUrl(payload.clickUrl);
      return;
    }

    const facilityIdRaw = payload.facilityId ? Number(payload.facilityId) : NaN;
    if (!isNaN(facilityIdRaw) && facilityIdRaw > 0) {
      await this.navigateToFacilityAlarmsReport(facilityIdRaw);
    }
  }

  /**
   * Wired from <top-nav (onNotificationsSeeAll)>. "See all" in the bell
   * dropdown — take the user to the alarms report for the currently
   * selected facility. No facility context means there's nothing global
   * to show, so fall back to the map (facility picker).
   */
  async onNotificationsSeeAll() {
    const currentFacility = this._appService.getFacilityID();
    if (currentFacility && currentFacility > 0) {
      await this.navigateToFacilityAlarmsReport(currentFacility);
      return;
    }
    this._router.navigate(['/map']);
  }

  /**
   * Resolve the active-alarms report URL for a facility and navigate.
   * Duplicates the minimal slice of SharedService.goToWithFacilityOrDevice
   * used here since we only know facilityId (not a full GearMapFacility).
   */
  private async navigateToFacilityAlarmsReport(facilityID: number) {
    try {
      const url = await this.sharedService.getFacilityActiveAlarmsReportUrl(facilityID);
      const [path, qs] = url.split('?');
      let queryParams: any = null;
      if (qs) {
        queryParams = JSON.parse('{"' + decodeURI(qs).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
      }
      this._appService.setFacilityID(facilityID);
      this._router.navigate([path], { queryParams });
    } catch (e) {
      // ReportingService already surfaces the error via showException.
      // Nothing else to do — bell stays closed, toast shown upstream.
    }
  }

  redirect() {
		let permissions = ['/default', '/customer'];

    if (!this._gearAppService.GearPermissionList || !this._gearAppService.GearPermissionList.Monitor) {
      return;
    }
    
    const _showFacilityMap = this._gearAppService.GearPermissionList.Monitor.AccessPermission.Maps.Facility;
    const _showDevicesMap = this._gearAppService.GearPermissionList.Monitor.AccessPermission.Maps.Device;
    const _showAlarmWithHeat = this._gearAppService.GearPermissionList.Monitor.AccessPermission.Maps.AlarmWithHeat;
    const _showDashboard = this.contains(this._gearAppService.GearPermissionList.Monitor.ClientDashboards, CoreTypes.PermissionOperation.Read);
    const _showDashboardList = this.contains(this._gearAppService.GearPermissionList.Monitor.ClientDashboards, CoreTypes.PermissionOperation.Edit);
    const _showDashboardAdd = this.contains(this._gearAppService.GearPermissionList.Monitor.ClientDashboards, CoreTypes.PermissionOperation.Create);
    const _showReports = this._gearAppService.GearPermissionList.Monitor.Reports.length>0;
    const _showTanks = this._gearAppService.GearPermissionList.Monitor.AccessPermission.Tanks;
    const _showPlans = this._gearAppService.GearPermissionList.Monitor.AccessPermission.Plans;
    const _showAssetTracking = this._gearAppService.GearPermissionList.Monitor.AccessPermission.AssetTracking;
    const addOnMapping = this._gearAppService.addOnFeaturesPermissionsList?.find(add => add.AddOnFeatureID == this.addOnFeatureIDs.Mapping);
    const _showIncidents = this.contains(this._gearAppService.GearPermissionList.Monitor.ClientIncidents, CoreTypes.PermissionOperation.Read);
    const _showEndpoints = this.containMenu(this.menuList, GearTypes.GearMenuHierarchyItem.Endpoints);

    if (_showFacilityMap || (addOnMapping && !addOnMapping.Enabled && addOnMapping.Visibility === this.addOnFeatureVisibility.ShowStar))
      permissions.push('/map');
    if (_showAlarmWithHeat || (this._router.url.indexOf('maps/custom') > -1) || (addOnMapping && !addOnMapping.Enabled && addOnMapping.Visibility === this.addOnFeatureVisibility.ShowStar))
      permissions.push('/maps');
    if (_showDevicesMap || (addOnMapping && !addOnMapping.Enabled && addOnMapping.Visibility === this.addOnFeatureVisibility.ShowStar))
      permissions.push('/devices-map');
		if (_showDashboard) {
			permissions.push('/dashboard');
    }
    if(_showDashboardList) {
      permissions.push('/dashboards');
      permissions.push('/dashboard/edit');
    }
    if(_showDashboardAdd){
      permissions.push('/dashboard/add');
    }
		if (_showTanks)
			permissions.push('/tanks');
		if (_showAssetTracking)
			permissions.push('/asset-tracking');
    if (_showPlans)
      permissions.push('/plans');
    if (_showReports)
		  permissions.push('/reports');

    if(_showIncidents) {
      permissions.push('/incident-map');
      permissions.push('/incident-management')
    }
/*     if(_showEndpoints || this._appService.getBaseURL().includes("mma-dev") ) {
      permissions.push('/devices');
    } */
    if(_showEndpoints) {
      permissions.push('/devices');
    }
    permissions.push('/plan');
    permissions.push('/plan/add');
    permissions.push('/plan/edit');
    permissions.push('/endpoints-history/history');
    permissions.push('/endpoints-history/comparative');
		const urlPieces = this._router.url.split('/');
		let matchUrl = 0;

		permissions.forEach(item => {
      if(this._router.url.indexOf('devices-map') > -1 && !_showDevicesMap) { return; }
      if((this._router.url === '/dashboards' || this._router.url.indexOf('dashboard/edit') > -1) && !_showDashboardList) return;
      if(this._router.url.indexOf('dashboard/add') > -1 && !_showDashboardAdd) { return; }
			if (this._router.url.indexOf(item) > -1)
				matchUrl++;
		});

		const founded = (matchUrl);

		if (this._router.url === '/' || ! this._router.url || ! founded){
			this._router.navigate([permissions[0]]);
    }
  }

  contains(list: any, elem: any) {
		return list.indexOf(elem) > -1;
	}

  containMenu(list: CoreTypes.MenuHierarchy[], elem: GearTypes.GearMenuHierarchyItem) {
    return list.find(item => item.MenuID === elem);
	}

  getActions(id) {
    this._gearProxyService.RealTimeDataService.GetDisplayClusterElementActions(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      id,
      async success => {
        this.sharedCommonService.getAccionsReturn.next(success);
      },
      error => {
        this._appService.showException(error);
      }
    );
  }

  /**
   * Capturar evento de postMessage emitido desde un iframe
   */
   @HostListener('window:message', ['$event']) onMessage(event) {
    try {
      const data = JSON.parse(event.data);
      if(data.action == 'noSnapshots' || data.action == 'deletedSnapshot' || data.action == 'snapshotsExist') { return; }
      const facility: GearTypes.GearMapFacility = {
        ...new GearTypes.GearMapFacility(),
        Description: data.facilityDesc,
        FacilityID: data.facilityId,
        Stats: {
          ...new GearTypes.GearMapFacilityStats(),
          DefaultIDs: {
            ...new GearTypes.FacilityMapDefaultIDs(),
            View: data.defaultViewId,
            Dashboard: data.dasboardUrl
          },
          Alarms: {
            ...new GearTypes.FacilityMapAlarmStats(),
          },
          URLs: {
            ... new GearTypes.FacilityMapURLs(),
            Stats: data.dasboardUrl
          }
        },
      }
 
      this.sharedService.goToWithFacilityOrDevice(facility, data.route);

      if(data.action === 'openCamera' && data.route)
        this._router.navigate(['/', {outlets: {modal: ['camera', btoa(data.route)]}}]);
    } catch(e) {
      return;
    }
  }
}
